var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-title"},[(_vm.subtitle)?_c('div',{class:'subtitle' + (_vm.isDark ? ' dark' : ''),domProps:{"innerHTML":_vm._s(_vm.subtitle)}}):_vm._e(),_c('div',{class:'title' + (_vm.isDark ? ' dark' : ''),domProps:{"innerHTML":_vm._s(_vm.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }